'use strict';

var jsxRuntime = require('react/jsx-runtime');

const LargeSearchConfirm = ({ disabled = false })=>{
    if (disabled) {
        return jsxRuntime.jsxs("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: "60",
            height: "60",
            viewBox: "0 0 60 60",
            fill: "none",
            "data-testid": "design-system-productIcon-icon-search_confirm--disabled",
            children: [
                jsxRuntime.jsx("circle", {
                    cx: "36.9956",
                    cy: "24",
                    r: "15",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("circle", {
                    cx: "37",
                    cy: "24",
                    r: "10",
                    fill: "#E0E0E0",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M33.5 23.5L36.125 26.5L40.5 21.5",
                    stroke: "white",
                    strokeWidth: "1.4",
                    strokeLinecap: "round",
                    strokeLinejoin: "round"
                }),
                jsxRuntime.jsx("rect", {
                    x: "20.7319",
                    y: "34.6066",
                    width: "8",
                    height: "20",
                    rx: "4",
                    transform: "rotate(45 20.7319 34.6066)",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M17.904 37.435C19.4661 35.8729 21.9988 35.8729 23.5608 37.435C25.1229 38.9971 25.1229 41.5298 23.5608 43.0918L22.2719 44.3808L16.6151 38.7239L17.904 37.435Z",
                    fill: "white",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4"
                }),
                jsxRuntime.jsx("path", {
                    d: "M26.3887 34.6066L23.5602 37.435",
                    stroke: "#9E9E9E",
                    strokeWidth: "1.4",
                    strokeLinecap: "round"
                })
            ]
        });
    }
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "60",
        height: "60",
        viewBox: "0 0 60 60",
        fill: "none",
        "data-testid": "design-system-productIcon-icon-search_confirm",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("circle", {
                cx: "36.9956",
                cy: "24",
                r: "15",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("circle", {
                cx: "37",
                cy: "24",
                r: "10",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M33.5 23.5L36.125 26.5L40.5 21.5",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("rect", {
                x: "20.7319",
                y: "34.6066",
                width: "8",
                height: "20",
                rx: "4",
                transform: "rotate(45 20.7319 34.6066)",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M17.904 37.435C19.4661 35.8729 21.9988 35.8729 23.5608 37.435C25.1229 38.9971 25.1229 41.5298 23.5608 43.0918L22.2719 44.3808L16.6151 38.7239L17.904 37.435Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M26.3887 34.6066L23.5602 37.435",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            })
        ]
    });
};
const MediumSearchConfirm = ()=>{
    return jsxRuntime.jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40",
        height: "40",
        viewBox: "0 0 40 40",
        fill: "none",
        className: "text-primary",
        children: [
            jsxRuntime.jsx("circle", {
                cx: "25.5",
                cy: "14.5",
                r: "10.5",
                fill: "currentColor",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M22 14L24.625 17L29 12",
                stroke: "white",
                strokeWidth: "1.4",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            jsxRuntime.jsx("rect", {
                width: "5.63181",
                height: "14.0795",
                rx: "2.81591",
                transform: "matrix(0.706981 0.707233 -0.706981 0.707233 13.9541 22.0595)",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            }),
            jsxRuntime.jsx("path", {
                d: "M17.9355 22.0595L15.9451 24.0507",
                stroke: "#212121",
                strokeWidth: "1.4",
                strokeLinecap: "round"
            }),
            jsxRuntime.jsx("path", {
                d: "M11.9734 24.0477C13.0743 22.9464 14.8593 22.9464 15.9602 24.0477C17.0611 25.149 17.0611 26.9346 15.9602 28.0359L15.0518 28.9446L11.065 24.9564L11.9734 24.0477Z",
                fill: "white",
                stroke: "#212121",
                strokeWidth: "1.4"
            })
        ]
    });
};
const SearchConfirm = ({ size, disabled = false })=>{
    if (size === 'medium') {
        return jsxRuntime.jsx(MediumSearchConfirm, {});
    }
    return jsxRuntime.jsx(LargeSearchConfirm, {
        disabled: disabled
    });
};

module.exports = SearchConfirm;
